// Enhanced Swatch Debug Logger V3 - Captures pre-click and post-click states
(function() {
  let clickCount = 0;
  let preClickState = {};
  let postClickState = {};
  
  function captureSwatchState(label) {
    const state = {
      timestamp: new Date().toISOString(),
      swatches: []
    };
    
    const debugElements = document.querySelectorAll('.swatch-debug');
    debugElements.forEach((elem, index) => {
      const swatchLabel = elem.closest('label');
      const inputElem = swatchLabel ? swatchLabel.querySelector('input[type="radio"]') : null;
      const colorValue = inputElem ? inputElem.value : 'Unknown';
      const swatchElem = swatchLabel ? swatchLabel.querySelector('.swatch') : null;
      const hasBackground = swatchElem && swatchElem.style.getPropertyValue('--swatch-background');
      const debugInfo = elem.getAttribute('data-debug');
      
      state.swatches.push({
        color: colorValue,
        hasBackground: !!hasBackground,
        backgroundValue: hasBackground || 'none',
        debugInfo: debugInfo,
        isChecked: inputElem ? inputElem.checked : false
      });
    });
    
    // Check web component state
    const variantPickers = document.querySelectorAll('swatches-variant-picker-component');
    state.webComponents = Array.from(variantPickers).map(picker => ({
      productId: picker.getAttribute('data-product-id'),
      hasConnectedCallback: picker.connectedCallback ? 'defined' : 'undefined',
      shadowRoot: picker.shadowRoot ? 'exists' : 'none',
      customElementState: customElements.get('swatches-variant-picker-component') ? 'registered' : 'not-registered'
    }));
    
    return state;
  }
  
  function logStateDifference() {
    console.log('=== SWATCH STATE COMPARISON ===');
    console.log('Click Count:', clickCount);
    
    // Compare pre and post states
    if (preClickState.swatches && postClickState.swatches) {
      console.log('\n📊 State Changes:');
      
      preClickState.swatches.forEach((preSwatch, i) => {
        const postSwatch = postClickState.swatches[i];
        if (!postSwatch) return;
        
        if (preSwatch.hasBackground !== postSwatch.hasBackground) {
          console.log(`✅ ${preSwatch.color}:`);
          console.log(`   Before: ${preSwatch.hasBackground ? 'HAD' : 'NO'} background`);
          console.log(`   After:  ${postSwatch.hasBackground ? 'HAS' : 'NO'} background (${postSwatch.backgroundValue})`);
          console.log(`   Debug Before: ${preSwatch.debugInfo}`);
          console.log(`   Debug After:  ${postSwatch.debugInfo}`);
        }
      });
    }
    
    // Log web component changes
    console.log('\n🔧 Web Component State:');
    if (postClickState.webComponents) {
      postClickState.webComponents.forEach(wc => {
        console.log(`Product ${wc.productId}:`, wc);
      });
    }
  }
  
  function logInitialState() {
    console.log('=== INITIAL PAGE LOAD STATE ===');
    const initialState = captureSwatchState('initial');
    preClickState = initialState;
    
    console.log(`Found ${initialState.swatches.length} swatches`);
    
    // Group by working/not working
    const working = initialState.swatches.filter(s => s.hasBackground);
    const notWorking = initialState.swatches.filter(s => !s.hasBackground);
    
    console.log(`✅ Working: ${working.length} swatches`);
    working.forEach(s => console.log(`   - ${s.color}: ${s.backgroundValue}`));
    
    console.log(`❌ Not Working: ${notWorking.length} swatches`);
    notWorking.forEach(s => console.log(`   - ${s.color}: ${s.debugInfo}`));
    
    // Check for deferred loading
    const deferredScripts = document.querySelectorAll('script[defer], script[type="module"]');
    console.log(`\n📦 Deferred/Module Scripts: ${deferredScripts.length}`);
    
    // Check for mutation observers
    if (typeof MutationObserver !== 'undefined') {
      console.log('MutationObserver: Available');
    }
  }
  
  // Intercept swatch clicks
  document.addEventListener('click', function(e) {
    const swatchLabel = e.target.closest('.variant-option__button-label');
    if (!swatchLabel) return;
    
    // Capture pre-click state
    if (clickCount === 0) {
      preClickState = captureSwatchState('pre-click');
      console.log('\n🖱️ FIRST SWATCH CLICK DETECTED');
      console.log('Pre-click state captured');
    }
    
    clickCount++;
    
    // Wait for DOM updates and re-render
    setTimeout(() => {
      postClickState = captureSwatchState('post-click');
      console.log(`\n🔄 POST-CLICK STATE (Click #${clickCount})`);
      
      // Log what was clicked
      const input = swatchLabel.querySelector('input');
      console.log(`Clicked: ${input ? input.value : 'unknown'}`);
      
      // Compare states
      logStateDifference();
      
      // Check for any new network requests
      if (window.performance && window.performance.getEntriesByType) {
        const resources = window.performance.getEntriesByType('resource');
        const recentResources = resources.filter(r => 
          r.startTime > performance.now() - 1000
        );
        if (recentResources.length > 0) {
          console.log('\n🌐 Recent Network Activity:');
          recentResources.forEach(r => {
            console.log(`   - ${r.name.split('/').pop()}`);
          });
        }
      }
      
      // Check if Liquid data changed
      const scriptTags = document.querySelectorAll('script[type="application/json"]');
      console.log(`\n📋 JSON Script Tags: ${scriptTags.length}`);
      
      // Re-check problematic colors
      console.log('\n🔍 Re-checking problematic colors:');
      const problemColors = ['Teal Blue', 'Dark Navy', 'Seafoam Green', 'Shocking Pink'];
      postClickState.swatches.forEach(s => {
        if (problemColors.some(pc => s.color.toLowerCase().includes(pc.toLowerCase()))) {
          console.log(`${s.color}: ${s.hasBackground ? '✅ NOW WORKING' : '❌ STILL NOT WORKING'}`);
        }
      });
      
    }, 500);
  }, true); // Use capture phase to catch event early
  
  // Monitor for dynamic content changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.classList && node.classList.contains('swatch')) {
          console.log('🆕 New swatch element added:', node);
        }
      });
    });
  });
  
  // Start observing
  setTimeout(() => {
    const containers = document.querySelectorAll('.variant-option--swatches');
    containers.forEach(container => {
      observer.observe(container, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
      });
    });
  }, 1000);
  
  // Initial state log
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(logInitialState, 1000);
    });
  } else {
    setTimeout(logInitialState, 1000);
  }
  
  // Add manual trigger for testing
  window.debugSwatches = {
    captureState: () => captureSwatchState('manual'),
    compareStates: logStateDifference,
    logCurrent: () => {
      const state = captureSwatchState('current');
      console.log('Current State:', state);
    }
  };
  
  console.log('🐛 Swatch Debug V3 Loaded - Monitoring for clicks...');
  console.log('   Use window.debugSwatches.logCurrent() to check state anytime');
})();